export default __webpack_public_path__ + "static/media/Yield My Flesh.572489f9.png";